import * as React from 'react';

import { Typography } from '../DesignSystemV2/Typography';

export const dolDinhLucAuthor = {
  name: 'DOL IELTS Đình Lực',
  avatarUrl:
    'https://dol-english-resource-dev.s3.ap-southeast-1.amazonaws.com/PUBLIC/MEDIA/32px_3f1e9833b1.png',
  authorAboutURL: '#',
  role: '',
  testimonialText: (
    <Typography.Paragraph ellipsis={{ rows: 3, expandable: true, symbol: 'see more' }}>
      DOL IELTS Đình Lực là trung tâm Anh ngữ hàng đầu tại thành phố Hồ Chí Minh với hệ phương pháp
      Linearthinking độc quyền đã được công nhận sự hiệu quả bởi hàng ngàn học viên tại DOL.
      <br />
      Nền tảng học trực tuyến miễn phí dolacademy.vn do DOL tạo ra với mục tiêu giúp tất cả những
      người học tiếng Anh tại Việt Nam có thể tiếp cận với 1 trải nghiệm học tập tốt hơn cùng 1 hệ
      phương pháp đúng đắn, tư duy và hiệu quả hơn.
    </Typography.Paragraph>
  ),
};
